(() => {
  if (window.__olivineCartGwpBound) return;
  window.__olivineCartGwpBound = true;

  const CAMPAIGN = 'cart_gwp';
  const SECTION_ID = () => window.MODULE_6_CART_SECTION_ID || 'cart-panel-drawer';

  const getConfig = () => window.MODULE_6_GWP_CONFIG || { enabled: false };

  const isGiftLine = (item) =>
    item?.properties?._is_gift === 'true' &&
    (item?.properties?._gift_campaign === CAMPAIGN ||
      item?.properties?._gift_campaign === getConfig().campaign);

  const cartRoot = () => window.Shopify?.routes?.root || '/';

  const fetchCart = async () => {
    const response = await fetch(`${cartRoot()}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('No se pudo leer el carrito');
    return response.json();
  };

  const hasTrigger = (cart, config) => {
    const triggerIds = Array.isArray(config.triggerProductIds)
      ? config.triggerProductIds.map(Number)
      : [];
    if (!triggerIds.length) return false;

    return (cart.items || []).some((item) => {
      if (isGiftLine(item)) return false;
      return triggerIds.includes(Number(item.product_id));
    });
  };

  const giftLines = (cart) => (cart.items || []).filter(isGiftLine);

  const changeLine = async (key, quantity) => {
    const response = await fetch(`${cartRoot()}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity,
        sections: SECTION_ID(),
        sections_url: window.location.pathname,
      }),
    });
    if (!response.ok) throw new Error('No se pudo actualizar la línea del carrito');
    return response.json();
  };

  const dispatchCartUpdated = (cart) => {
    document.dispatchEvent(
      new CustomEvent('product-added', {
        bubbles: true,
        detail: { ...cart, __gwpSynced: true },
      })
    );
  };

  const syncGiftRules = async (incomingCart) => {
    const config = getConfig();
    if (!config.enabled || window.__gwpSyncing) return incomingCart;

    let cart = incomingCart;
    if (!cart || !Array.isArray(cart.items)) {
      cart = await fetchCart();
    }

    const gifts = giftLines(cart);
    const triggerPresent = hasTrigger(cart, config);
    const giftProductIds = Array.isArray(config.giftProductIds)
      ? config.giftProductIds.map(Number)
      : [];

    const removals = [];

    if (!triggerPresent) {
      gifts.forEach((gift) => removals.push(gift.key));
    } else {
      gifts.forEach((gift, index) => {
        const invalidProduct =
          giftProductIds.length > 0 && !giftProductIds.includes(Number(gift.product_id));
        if (invalidProduct || index > 0) {
          removals.push(gift.key);
          return;
        }
        if (Number(gift.quantity) > 1) {
          removals.push({ key: gift.key, quantity: 1 });
        }
      });
    }

    if (!removals.length) return cart;

    window.__gwpSyncing = true;
    try {
      let latest = cart;
      for (const removal of removals) {
        if (typeof removal === 'string') {
          latest = await changeLine(removal, 0);
        } else {
          latest = await changeLine(removal.key, removal.quantity);
        }
      }
      dispatchCartUpdated(latest);
      return latest;
    } finally {
      window.__gwpSyncing = false;
    }
  };

  const showHint = (root) => {
    const hint = root?.querySelector('[data-gwp-hint]');
    if (!hint) return;
    hint.hidden = false;
    window.clearTimeout(showHint._timer);
    showHint._timer = window.setTimeout(() => {
      hint.hidden = true;
    }, 3200);
  };

  const addGift = async (button) => {
    const config = getConfig();
    if (!config.enabled) return;

    const variantId = Number(button.getAttribute('data-variant-id'));
    if (!variantId || button.disabled) return;

    button.disabled = true;
    const originalLabel = button.textContent;
    button.textContent = 'Agregando';

    try {
      const cart = await fetchCart();
      if (!hasTrigger(cart, config)) return;

      if (giftLines(cart).length > 0) {
        showHint(button.closest('[data-cart-gwp]'));
        return;
      }

      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _is_gift: 'true',
                _gift_campaign: config.campaign || CAMPAIGN,
              },
            },
          ],
          sections: SECTION_ID(),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error('No se pudo agregar el regalo');

      // Refrescamos con cart.js completo + sync
      const freshCart = await fetchCart();
      await syncGiftRules(freshCart);
      dispatchCartUpdated(freshCart);
    } catch (error) {
      console.error(error);
    } finally {
      button.disabled = false;
      button.textContent = originalLabel || 'Agregar';
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-gwp-add]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      addGift(button);
    },
    true
  );

  document.addEventListener('product-added', (event) => {
    if (event.detail?.__gwpSynced) return;
    if (window.__gwpSyncing) return;
    syncGiftRules(event.detail).catch((error) => console.error(error));
  });

  // Sync inicial por si el carrito ya viene inconsistente
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        if (!getConfig().enabled) return;
        fetchCart()
          .then((cart) => syncGiftRules(cart))
          .catch(() => {});
      },
      { once: true }
    );
  } else if (getConfig().enabled) {
    fetchCart()
      .then((cart) => syncGiftRules(cart))
      .catch(() => {});
  }
})();
